import * as React from 'react'
import { connect } from 'react-redux'
import type { RootState, Dispatch } from '../../app/store'
import type { DeliveryType } from '../../utils/deliveryHelper'
import { getFormattedPriceByDeliveryType } from '../../utils/formattedPrice'
import type { AddOnT } from '../../models/menus'
import styles from './AddOns.module.css'

type AddOnsT = {
  storeId: string,
  restaurantId: string,
  addOns: Array<AddOnT>
  fetchAddOns: (restaurantId: string) => void
  addItemToCart: (payload: { storeId: string, productId: string, itemType: number }) => void,
  deliveryType: DeliveryType,
}

function AddOns ({ addOns, fetchAddOns, addItemToCart, storeId, restaurantId, deliveryType }: AddOnsT) {

  React.useEffect(() => {
    fetchAddOns(restaurantId)
  }, [fetchAddOns, restaurantId])

  function onAddItem (productId: string, itemType: number) {
    addItemToCart({
      storeId,
      productId,
      itemType
    })
  }

  return addOns && addOns.length > 0 ? (
    <div className={styles.addons}>
      <h2 className={styles.heading}>Lägg till fler varor</h2>
      {addOns.map(({ id, Name, products }) => (
        <div className={styles.group} key={id}>
          <h3 className={styles.groupHeading}>{Name}</h3>
          <ul className={styles.list}>
            {products.map((product) => (
              <li className={styles.item} key={product.id}>
                <div className={styles.itemContent}>
                  {product.imageUrl && (
                    <div className={styles.info}>
                      <img className={styles.image} src={product.imageUrl} alt={product.groceryDisplayName} />
                    </div>
                  )}
                  <div className={styles.summary}>
                    <p className={styles.name}>{product.groceryDisplayName}</p>
                    <div className={styles.priceContainer}>
                      <span className={styles.price}>{getFormattedPriceByDeliveryType(product, deliveryType)}</span>
                      <button onClick={() => onAddItem(product.id, product.itemType)} className={styles.addButton} type="button">Lägg till</button>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  ) : null
}

function mapState (state: RootState) {
  return {
    addOns: state.menus.addOns,
    deliveryType: state.cart.deliveryType,
  };
}
function mapDispatch (dispatch: Dispatch) {
  return {
    fetchAddOns: dispatch.menus.fetchAddOns,
    addItemToCart: dispatch.cart.addItemToCart,
  };
}

export default connect(mapState, mapDispatch)(AddOns)